import { module as m } from 'modujs';
import gsap from 'gsap';

export default class extends m {
    constructor(m) {
        super(m);

        // DOM
        this.dom = {};
        this.dom.items = this.el.querySelectorAll('.has-children');

        // FUNC
        this._toggle = this._toggle.bind(this);

        // EVENTS
        this.events = {
            click: {
                'close': '_close'
            }
        }
    }

    /**
     * INIT
     */
    init() {
        this.dom.items.forEach((item) => {
            item.addEventListener('click', this._toggle);
        });
    }

    /**
     * START
     */
    start() {}

    /**
     * DESTROY
     */
    destroy() {}

    /**
     * SHOW
     */
    show() {
        gsap.to(".menu-mobile", {
            duration: 0.6,
            autoAlpha: 1,
            ease: 'power4.out'
        });
    }

    /**
     * CLOSE
     */
    _close() {
        gsap.to(".menu-mobile", {
            duration: 0.6,
            autoAlpha: 0,
            ease: 'power4.out'
        });
    }

    /**
     * TOGGLE
     * @private
     */
    _toggle(event) {
        const target = event.currentTarget;
        const list = target.querySelector('ul');

        if(!list.classList.contains('is-open')) {
            list.classList.add('is-open');
            list.style.height = 'auto';
        } else {
            list.classList.remove('is-open');
            list.style.height = '0';
        }
    }
}
